import useQueryErrorHandler from './useQueryErrorHandler';
export default useQueryErrorHandler;

export const QUERY_ERROR_RESPONSE = {
    INTERNAL_SERVER_ERROR: 'Internal server Error',
    INVALID_AUTH_TOKEN: 'Invalid auth token.',
    EXPIRED_AUTH_TOKEN: 'Expired auth token.',
} as const;
